import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import UpdateIcon from '@mui/icons-material/Update'
import AddIcon from '@mui/icons-material/Add'
import Modal from '@mui/material/Modal'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import MenuItem from '@mui/material/MenuItem'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Sidebar from '../sidebar'
import NavLogo from '../NavLogo'
import { Col, Row } from 'react-bootstrap'
import { MDBDataTable } from 'mdbreact'
import DeleteIcon from '@mui/icons-material/Delete'
import { TextareaAutosize } from '@mui/material'
import {
  RuleMasterAddApi,
  RuleMasterDeleteApi,
  RuleMasterFindallApi,
  RuleMasterUpdateApi,
} from '../../ApiFile'
import MobileNavbarAdmin from './MobileNavbarAdmin'

const AdmissionRuleMaster = () => {
  const [showModal, setShowModal] = useState(false)
  const [rules, setRules] = useState([])
  const [serialNo, setSerialNo] = useState('')
  const [description, setDescription] = useState('')
  const [isEditing, setIsEditing] = useState(false)
  const [open, setOpen] = useState(false)
  const [error, setError] = useState(null)
  const [editId, setEditId] = useState(null) // New state to track the ID of the item being edited
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
   const [deleteId, setDeleteId] = useState(null)

  useEffect(() => {
    fetchRuleData()
  }, [])

  const fetchRuleData = async () => {
    try {
      const response = await fetch(RuleMasterFindallApi)
      if (!response.ok) {
        throw new Error('Failed to fetch block data')
      }

      const data = await response.json()

      if (data === 'NOTFOUND') {
        setRules([]) // Set rules to an empty array if "NOTFOUND"
      } else {
        setRules(data)
      }
    } catch (error) {
      // console.error('Error fetching block data:', error);
    }
  }

  const handleOpen = (id = null) => {
    // Modified to accept an optional parameter for editing
    setOpen(true)
    setIsEditing(id !== null)
    if (id !== null) {
      // If editing, set the initial state with the data of the row being edited
      const item = rules.find((rule) => rule.id === id)
      if (item) {
        setEditId(id)
        setSerialNo(item.serial_no)
        setDescription(item.description)
      }
    } else {
      setSerialNo('')
      setDescription('')
    }
  }

  const handleClose = () => {
    setOpen(false)
    setIsEditing(false)
    setSerialNo('')
    setDescription('')
  }

  const savedata = async (e) => {
    e.preventDefault()

    const trimmedSerialNo = String(serialNo).trim()
    const trimmedDescription = String(description).trim()

    // Validation for mandatory fields
    if (!trimmedSerialNo || !trimmedDescription) {
      toast.error('Serial No and Description are mandatory fields.')
      return
    }

    try {
      if (isEditing) {
        const bodyData = {
          serial_no: trimmedSerialNo,
          description: trimmedDescription,
        }

        const response = await fetch(`${RuleMasterUpdateApi}/${editId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(bodyData),
        })
        if (!response.ok) {
          throw new Error('Failed to update')
        }
        toast.success('Data updated successfully')
      } else {
        const bodyData = {
          serial_no: trimmedSerialNo,
          description: trimmedDescription,
        }

        const response = await fetch(RuleMasterAddApi, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(bodyData),
        })
        if (!response.ok) {
          throw new Error('Failed to add')
        }
        toast.success('Data saved successfully')
      }
      fetchRuleData()
      handleClose()
    } catch (error) {
      console.error('Error adding/updating:', error)
    }
  }

  const deleteData = async () => {
    try {
      const response = await fetch(`${RuleMasterDeleteApi}/${deleteId}`, {
        method: 'DELETE',
      })
      if (!response.ok) {
        throw new Error('Failed to delete')
      }
      toast.success('Data deleted successfully')
      fetchRuleData()
       handleDeleteModalClose()
    } catch (error) {
      // console.error('Error deleting:', error);
      setError('Failed to delete ')
       handleDeleteModalClose()
    }
  }

  const columns = [
    { label: 'Serial No', field: 'serial_no', sort: 'asc' },
    { label: 'Description', field: 'description', sort: 'asc' },
    { label: 'Edit', field: 'edit', sort: 'asc' },
    { label: 'Delete', field: 'delete', sort: 'asc' },
  ]

  const rows = rules.map((item, index) => ({
    id: item.id, //
    serial_no: item.serial_no,
    description: item.description,
    edit: (
      <>
        <button
          className="m-1"
          style={{
            color: 'rgb(255, 93, 0)',
            border: '0px',
            backgroundColor: 'transparent',
          }}
          onClick={() => handleOpen(item.id)}
        >
          <UpdateIcon />
        </button>
      </>
    ),
    delete: (
      <>
        <button
          className="m-1"
          style={{
            color: 'rgb(255, 0, 0)',
            border: '0px',
            backgroundColor: 'transparent',
          }}
          onClick={() => handleDeleteModalOpen(item.id)}
        >
          <DeleteIcon />
        </button>
      </>
    ),
  }))

   const handleDeleteModalOpen = (id) => {
    setDeleteId(id)
    setDeleteModalOpen(true)
  }

  const handleDeleteModalClose = () => {
    setDeleteModalOpen(false)
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
                          {/* Sidebar on the left for desktop */}
                          <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
                            <Sidebar />
                          </div>
                    
                          {/* Main content on the right */}
                          <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
                            <NavLogo />
             
                   <div className="d-block d-md-none">
                     <MobileNavbarAdmin />
                   </div>

        <div className="border w-100 h-100 py-3" style={{backgroundColor:"#f5f5f5ff"}}>
          <div className="row m-0 block-header ps-3">
          <div className='col-12 col-md-6'>
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
              Admission Rule
            </h5>
            </div>
            <div className='col-12 col-md-6 text-end'>
               <Button
              className="ms-md-5 m-0  ms-3  mb-2 mb-md-4 mt-2 mt-md-4"
              variant="contained"
              color="primary"
              onClick={() => handleOpen()} // Modified to call handleOpen directly
              startIcon={<AddIcon />}
            >
              Add Rule
            </Button>
            </div>
          </div>
           

          <Row
            className="m-0 p-0  px-md-3  py-1 pb-5  w-100"
            style={{ display: 'flex' }}
          >
            <Row className="m-0 pt-1 px-2 px-md-3 mb-5 rounded">
              <Col
                className="m-0 p-0  px-3 py-3 rounded shadow"
                style={{ background: 'white' }}
              >
                <div style={{ overflowY: 'auto' }}>
                  <div style={{ overflowX: 'auto' }}>
                    <MDBDataTable
                      striped
                      className="custom-datatable"
                      bordered
                      hover
                      data={{ columns, rows }}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style}>
                <Typography variant="h6" className="mt-2" component="h2">
                  Admission Rule Master
                </Typography>
                <form>
                  <TextField
                    type="number"
                    label="Serial No"
                    value={serialNo}
                    onChange={(e) => setSerialNo(e.target.value)}
                    fullWidth
                    style={{ marginBottom: '20px' }}
                  />

                  <TextareaAutosize
                    minRows={4}
                    label="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    style={{ width: '100%', marginBottom: '20px' }}
                  />
                </form>
                <Row>
                  <Col className="text-end">
                    <Button
                      className="mt-4"
                      style={{
                        color: 'black',
                        backgroundColor: 'white',
                        border: '2px solid #9ce3ff',
                        borderRadius: '8',
                      }}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      style={{
                        border: '0px',
                        backgroundColor: '#9ce3ff',
                      }}
                      className="py-2 px-3 mt-4 shadow text-dark"
                      type="submit"
                      onClick={savedata}
                    >
                      {isEditing ? 'Update' : 'Save'}
                    </Button>
                  </Col>
                </Row>
              </Box>
            </Modal>
          </Row>

            {/* Delete Confirmation Modal */}
            <Modal open={deleteModalOpen} onClose={handleDeleteModalClose}>
              <Box sx={style}>
                <Typography variant="h6" component="h2">
                  Confirm Deletion
                </Typography>
                <Typography sx={{ mt: 2 }}>
                  Are you sure you want to delete this record?
                </Typography>
                <Row className="mt-4">
                  <Col className="text-end">
                    <Button
                      style={{
                        color: 'black',
                        backgroundColor: 'white',
                        border: '2px solid #9ce3ff',
                        borderRadius: '8',
                      }}
                      onClick={handleDeleteModalClose}
                    >
                      Cancel
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      style={{
                        border: '0px',
                        backgroundColor: 'rgb(255, 0, 0)',
                      }}
                      className="py-2 px-3 shadow text-white"
                      onClick={deleteData}
                    >
                      Confirm
                    </Button>
                  </Col>
                </Row>
              </Box>
            </Modal>

        </div>
      </div>
      </div>
    </>
  )
}

export default AdmissionRuleMaster
